<template>
  <div>
    <router-view v-show="$route.matched.length == 3"></router-view>
    <PageHeaderLayout v-show="$route.matched.length == 2">
      <div class="main-page-content">
        <el-row style="height: 36px">
          <el-form :inline="true" :model="searchCondition">
            <el-form-item label="姓名">
              <el-input
                v-model="searchCondition.name"
                placeholder="输入姓名"
                class="item-name"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="公司">
              <el-input
                v-model="searchCondition.company_name"
                placeholder="输入姓名"
                class="item-name"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="状态">
              <el-select v-model="searchCondition.status" placeholder="请选择" filterable clearable  :multiple-limit=1>
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="时间">
              <DatePicker @dataSearch="dataSearch" />
            </el-form-item>
            <el-form-item>
              <el-button @click="searchButton" style="color: #1890ff"
                >查询</el-button
              >
            </el-form-item>
          </el-form>
        </el-row>
        <ApeTable
          ref="apeTable"
          :data="companyList"
          :columns="columns"
          :loading="loadingStaus"
          :pagingData="pagingData"
          @switchPaging="switchPaging"
          highlight-current-row
        >
          <el-table-column
            width="180"
            header_align="center"
            align="center"
            label="操作"
          >
            <template slot-scope="scope">
              <span>
                <el-button size="mini" @click="handleButton(scope.row.id)" type="primary" v-if="scope.row.status == 1">办理</el-button>
                <el-button size="mini" @click="viewButton(scope.row.id)">详情</el-button>
                <el-popover
                  placement="top"
                  width="150"
                  v-model="scope.row.visible">
                  <p>确定要删除记录吗？</p>
                  <div style="text-align: right; margin: 0;">
                    <el-button type="text" size="mini" @click="scope.row.visible=false">取消</el-button>
                    <el-button type="danger" size="mini" @click="deleteButton(scope.row.id)">确定</el-button>
                  </div>
                  <el-button slot="reference" type="danger" size="mini" >删除</el-button>
                </el-popover>
              </span>
            </template>
          </el-table-column>
        </ApeTable>
      </div>
    </PageHeaderLayout>
    <!-- 审核模态框 -->
     <ModalDialog :dialogData="examineDialogData" @dialogConfirm="examineHandleConfirm" @dialogClose="examineDialogClose">
      <template slot="content">
        <el-form :model="examineRuleForm" ref="examineRuleForm" class="demo-ruleForm" :label-position="'right'" >
          <el-form-item>
            <el-radio-group v-model="examineRuleForm.status">
              <el-radio label="1">通过</el-radio>
              <el-radio label="2">拒绝</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="examineRuleForm.status == 2">
            <el-input type="textarea" :rows="4" v-model="examineRuleForm.remark" placeholder="请输入拒绝原因"></el-input>
          </el-form-item>
        </el-form>
      </template>
    </ModalDialog>
    <!-- 办理模态框 -->
    <ModalDialog :dialogData="handleDialogData" @dialogConfirm="handleConfirm" @dialogClose="handleDialogClose">
      <template slot="content">
        <el-form :model="handleRuleForm" ref="handleRuleForm" class="demo-ruleForm" :label-position="'right'" >
          <el-form-item>
            <el-radio-group v-model="handleRuleForm.status">
              <el-radio label="2">办理成功</el-radio>
              <el-radio label="3">办理失败</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="handleRuleForm.status == 5">
            <el-input type="textarea" :rows="4" v-model="handleRuleForm.remark" placeholder="请输入办理失败原因"></el-input>
          </el-form-item>
        </el-form>
      </template>
    </ModalDialog>
  </div>
</template>

<script>
import PageHeaderLayout from "@/layouts/PageHeaderLayout";
import ApeTable from "@/components/ApeTable";
import DatePicker from "@/components/DatePicker.vue";
import ModalDialog from '@/components/ModalDialog'
import { mapGetters, mapState } from "vuex";

export default {
  components: {
    PageHeaderLayout,
    ApeTable,
    DatePicker,
    ModalDialog
  },
  data() {
    return {
      examineDialogData: {//审核模态框
        visible: false,
        title: '',
        width: '40%',
        loading: true,
        modal: false
      },
      examineRuleForm: {//审核表单数据
        id: '',
        status: '',
        remark: ''
      },
      handleDialogData: {
        visible: false,
        title: '',
        width: '40%',
        loading: true,
        modal: false
      },
      handleRuleForm: {
        id: '',
        status: '',
        remark: ''
      },
      searchCondition: {},
      companyList: [],
      columns: [
        {
          title: '身份信息',
          width: 360,
          header_align: 'center',
          value: [
            {label:'姓名：',value:'name',width: 100},
            {label:'身份证号：',value:'idcard',width: 100},
            {label:'身份证地址：',value:'address',width: 100},
            {label:'邮箱：',value:'email',width: 100},
          ],
        },
        {
          title: '银行信息',
          width: '300',
          header_align: 'center',
          align: 'left',
          value: [
            {label:'开户行：',value:'bank'},
            {label:'银行卡：',value:'bank_card'},
          ],
        },
        {
          title: '公司名',
          value: 'company_name',
          header_align: 'center',
          align: 'center',
        },
        {
          title: '手机号',
          header_align: 'center',
          align: 'center',
          value: 'mobile',
        },
        {
          title: '身份证正面照片',
          type: 'image',
          value: 'idcard_front',
          header_align: 'center',
          align: 'center',
        },
        {
          title: '身份证反面照片',
          type: 'image',
          value: 'idcard_back',
          header_align: 'center',
          align: 'center',
        },
        {
          title: '状态',
          value: 'alias_status',
          header_align: 'center',
          align: 'center',
        },
        {
          title: '驳回原因',
          value: 'remark',
          header_align: 'center',
          align: 'center',
        },
        {
          title: '创建时间',
          value: 'created_at',
          header_align: 'center',
          align: 'center',
        },
      ],
      options: [{
        value: '1',
        label: '办理中'
      },{
        value: '2',
        label: '办理成功'
      }, 
      {
        value: '3',
        label: '办理失败'
      }],
      // 分页信息
      pagingData:{
        is_show: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0
      },
      // 分页的offset,序号列使用
      offset:0,
      loadingStaus: true,
    };
  },

  computed: {
    ...mapGetters(["userPermissions", "buttonType"]),
    ...mapState({
      userInfo: (state) => state.userInfo,
    }),
  },
  watch: {
    "$route.matched": function (n, o) {
      console.log(o);
      if (n.length === 2) {
        this.init();
      }
    },
    "examineRuleForm.status": function(val) {
      if(val) {
        this.examineDialogData.loading = false
      }else {
        this.examineDialogData.loading = true
      }
    },
    "handleRuleForm.status": function(val) {
      if(val) {
        this.handleDialogData.loading = false
      }else {
        this.handleDialogData.loading = true
      }
    }
  },
  methods: {  
    //删除 
    async deleteButton(id) {
      let args = {
        id
      }
      let result = await this.$api.individualDelete(args)
      if(result) {
        this.init()
        this.$message.success('删除成功')
      }
    },
    // 响应详情按钮
    async viewButton(id) {
      this.$router.push(this.$route.path+'/'+id+'/view')
    },
    //个体户审核
    async individualAudit() {
      let result = await this.$api.individualAudit(this.examineRuleForm)
      if(result) {
        this.examineDialogData.visible = false
        this.examineRuleForm = {}
        this.init()
        this.$message.success('审核完成')
      } 
    },
    //个体户办理
    async individualHandle() {
      let result = await this.$api.individualAudit(this.handleRuleForm)
      if(result) {
        this.handleDialogData.visible = false
        this.handleRuleForm = {}
        this.init()
        this.$message.success('办理完成')
      }
    },
    //审核确定模态框
    examineHandleConfirm() {
      this.$refs['examineRuleForm'].validate((valid) => {
        if(valid) {
          this.individualAudit()
        }
      })
    },
    //审核关闭模态框
    examineDialogClose() {
      this.examineDialogData.visible = false
      this.examineRuleForm = {}
    },
    //办理确定模态框
    handleConfirm() {
      this.$refs['handleRuleForm'].validate((valid) => {
        if(valid) {
          this.individualHandle()
        }
      })
    },
    //办理关闭模态框
    handleDialogClose() {
      this.handleDialogData.visible = false
      this.handleRuleForm = {}
    },
    //查询按钮
    searchButton() {
      this.init('search')
    },  
    //获取选中日期的值
    dataSearch(value) {
      this.searchCondition.start_time = value[0];
      this.searchCondition.end_time = value[1];
    },
    // 初始化列表
    async init(type) {
      if (type) {
        this.mxResetPage();
      }
      let pagingInfo = this.$refs["apeTable"].getPagingInfo(type);
      if (type == "search") {
        pagingInfo.current_page = 1;
      }
      let searchCondition = this.handleSearchCondition();
      Object.assign(searchCondition, pagingInfo);
      let { list, pages } = await this.$api.getIndividualList(searchCondition);
      this.companyList = list;
      this.pagingData.total = pages.total;
      this.offset = pages.offset;
      this.loadingStaus = false;
    },
    // 处理搜索条件
    handleSearchCondition() {
      let condition = {};
      if (this.searchCondition.name) {
        condition.name = this.searchCondition.name;
      }
      if (this.searchCondition.company_name) {
        condition.company_name = this.searchCondition.company_name;
      }
      if (this.searchCondition.status) {
        condition.status = this.searchCondition.status;
      }
      if (this.searchCondition.start_time) {
        condition.start_time = this.searchCondition.start_time
      }
      if (this.searchCondition.end_time) {
        condition.end_time = this.searchCondition.end_time
      }
      return condition;
    },
    //分页
    switchPaging() {
    this.init();
    },
    //审核操作
    examineButton(id) {
      this.examineDialogData.visible = true
      this.examineRuleForm.id = id
    },
    //办理操作
    handleButton (id) {
      this.handleDialogData.visible = true
      this.handleRuleForm.id = id
    }
  },
  mounted() {
    this.init();
  },
};
</script>

<style lang="stylus" scoped>
/deep/.el-checkbox-group label {
  width: 180px;
}

/deep/.el-checkbox-group label:first-child {
  margin-left: 10px;
}

/deep/.el-checkbox-group {
  // width: 660px
}

.el-button {
  margin-right: 4px;
  margin-bottom: 4px;
}

.item-name {
  width: 130px;
}

.table-header-gai {
  height: 35px;
}

.table-header {
  margin-bottom: 12px;
}

.el-popover .el-checkbox-group .el-checkbox {
  margin-left: 0px;
  margin-right: 12px;
}

.returnBtn {
  position: relative;
  top: 10px;
  float: right;
}

.table-right {
  float: right;
}

.submitBtn {
  float: right;
  margin-top: 20px;
}

.link-url {
  color: #fff;
  text-decoration: none;
}

.cusomer-link-gai {
  position: absolute;
  top: 0;
  font-size: 15px;
  width: 160px;
}

.cusomer-link {
  position: absolute;
  top: 0;
  right: 0;
}

.total-num {
  float: right;
  margin-top: 10px;
  margin-right: 20px;
  // position: absolute;
  // top: 0
  // right: 0
  // line-height: 40px
  // padding-right: 20px
}

.span-num {
  color: #f00;
}

.selectWord {
  width: 150px;
}

.link-title {
  text-align: center;
  padding-bottom: 10px;
  color: red;
}

.people-btn-wrapper {
  margin-top: 20px;
}

.dialog-title {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  margin-top: -20px;
}

.title-text {
  font-size: 20px;
  margin-left: 10px;
}

.center-box {
  display: flex;
  justify-content: center;
  align-item: center;
  padding: 30px 0;
}

.QR-code {
  width: 150px;
  height: 150px;
}

.main-page-content {
  position: relative;
}

.select-box {
  width: 100px;
}
</style>
